import React from "react";
import { Box, Typography } from "@mui/material";
import useAuth from "../../hooks/useAuth";
import FarmOverviewPanel from "../../components/dashboard/FarmOverviewPanel";
import AdminQuickLinks from "../../components/dashboard/AdminQuickLinks";

const AdminDashboard = () => {
  const { user } = useAuth();

  return (
    <Box
      sx={{
        minHeight: "100%",
        pb: 4,
        pt: { xs: 2, md: 3 },
        px: { xs: 2, md: 3 },
        bgcolor: "background.default",
      }}
    >
      <Box sx={{ maxWidth: 1200, mx: "auto" }}>
        <Typography variant="h4" gutterBottom sx={{ fontWeight: 700 }}>
          Dashboard
        </Typography>
        <Typography variant="subtitle1" color="text.secondary" gutterBottom>
          Welcome back, {user?.firstname || "Admin"}
        </Typography>

        <Box sx={{ mt: 1 }}>
          <FarmOverviewPanel sectionTitle="Herd overview" />
        </Box>

        <AdminQuickLinks />
      </Box>
    </Box>
  );
};

export default AdminDashboard;
